import {
  Checkbox,
  FormControl,
  FormControlProps,
  FormErrorMessage,
  FormLabel,
  Input,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Select,
  Text,
} from '@chakra-ui/react';
import { HTMLInputTypeAttribute } from 'react';
import { RegisterOptions, useFormContext } from 'react-hook-form';

interface Props extends FormControlProps {
  name: string;
  label?: string;
  type?: HTMLInputTypeAttribute | 'select' | 'money';
  register?: RegisterOptions;
}

function Field({
  name,
  label,
  register: registerOptions = {},
  type = 'text',
  children,
  placeholder,
  ...props
}: Props) {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const error = errors[name];

  return (
    <FormControl isInvalid={!!error} {...props}>
      {label && type !== 'checkbox' && (
        <FormLabel>
          {registerOptions.required && (
            <Text as="span" mr={1} color="purple.500" fontSize="xl">
              *
            </Text>
          )}
          {label}
        </FormLabel>
      )}
      {type === 'checkbox' && (
        <Checkbox {...register(name, registerOptions)}>
          <Text fontWeight="medium">{label}</Text>
        </Checkbox>
      )}
      {type === 'select' && (
        <Select {...register(name, registerOptions)} placeholder={placeholder}>
          {children}
        </Select>
      )}
      {type === 'money' && (
        <NumberInput>
          <NumberInputField {...register(name, registerOptions)} />
          <NumberInputStepper>
            <NumberIncrementStepper />
            <NumberDecrementStepper />
          </NumberInputStepper>
        </NumberInput>
      )}
      {!['checkbox', 'select', 'money'].includes(type) && (
        <Input type={type} {...register(name, registerOptions)} placeholder={placeholder} />
      )}
      {error && <FormErrorMessage>{error?.message}</FormErrorMessage>}
    </FormControl>
  );
}

export default Field;
